import "../CSS/tantramassagemann.css";

import TantramassageNavigation
    from "../components/TantramassageNavigation";


function TantramassageMannPage() {

    return (
        <>

            <TantramassageNavigation />


            <div className="intro">

                <h1>
                    Tantramassage für Männer im Sarganserland
                </h1>

            </div>


            <main className="massage-mann-main">

                <section className="massage-mann-einstieg">

                    <figure className="massage-mann-bild">

                        <img
                            src="/Fotos/massage_mann.png"
                            alt="Achtsame Tantramassage für Männer im Sarganserland"
                        />

                        <figcaption>
                            Achtsamkeit, Berührung und Zeit für Dich
                        </figcaption>

                    </figure>


                    <div className="massage-mann-text">

                        <p>
                            Meine Tantramassage für Männer im
                            Sarganserland ist eine Einladung,
                            zur Ruhe zu kommen, den eigenen Körper bewusst
                            wahrzunehmen und Berührung ohne Leistungsdruck
                            zu erleben. Mein Angebot richtet sich auch an
                            Männer aus Mels, Sargans, Bad Ragaz und der
                            umliegenden Region.
                        </p>


                        <p>
                            In einem geschützten und wertschätzenden Rahmen
                            darfst Du loslassen und Dir Zeit für Dich und
                            Deinen Körper nehmen.
                        </p>


                        <p>
                            Im Mittelpunkt stehen Achtsamkeit, Präsenz und
                            das bewusste Spüren.
                        </p>


                        <p>
                            Es geht nicht darum, etwas erreichen oder
                            leisten zu müssen, sondern darum, den Moment
                            wahrzunehmen und Dich ganz auf die Berührung
                            einzulassen.
                        </p>

                    </div>

                </section>


                <section className="massage-mann-details">

                    <h2>
                        Die Lingam-Massage
                    </h2>


                    <p>
                        Die Massage kann den ganzen Körper mit einbeziehen.
                        Wenn Du es ausdrücklich wünschst und wir dies vorher
                        gemeinsam vereinbart haben, kann auch eine
                        Lingam-Massage Teil Deiner Tantramassage sein.
                    </p>


                    <p>
                        Der Lingam ist der tantrische Begriff für das
                        männliche Geschlechtsorgan. Die Lingam-Massage kann
                        sinnlich und lustvoll, aber ebenso entspannend und
                        achtsam erlebt werden. Dabei gibt es kein Ziel,
                        das erreicht werden muss.
                    </p>


                    <p>
                        Du entscheidest jederzeit selbst, welche Berührungen
                        für Dich stimmig sind. Deine Wünsche und persönlichen
                        Grenzen stehen während der gesamten Massage im
                        Vordergrund.
                    </p>

                </section>

            </main>

        </>
    );
}


export default TantramassageMannPage;